export const ERROR_CONTENT = {
  TITLE: "Не удалось отправить оценку",
  DESCRIPTION:
    "Попробуйте ещё раз или вернитесь на предыдущий экран, чтобы изменить оценку",
  BUTTON: {
    BACK: "Вернуться в историю",
    RETRY: "Повторить попытку",
  },
};
